/**
 * We are creating this const due to graphics issues.
 * if you try to set this constant to 0, you will see the issues.
 */
export const AUTHENTICATION_MS = 300;
